import { UserProfile } from './user.model';

export enum MenteeSeniority {
  Trainee = 'Trainee',
  Junior = 'Junior',
}

export enum MenteeStatus {
  Probation = 'Probation',
  Active = 'Active',
  Offboarding = 'Offboarding',
}

export enum MenteePlanStatus {
  InProgress = 'inProgress',
  Finished = 'finished',
  NotStarted = 'notStarted',
  NotAssigned = 'notAssigned',
}

export interface MentorUser extends UserProfile {
  wasMentor: true;
  currentMenteesCount: 0;
}
